/* el-accordion-motion.js — shared by the Ecomlanders accordions
   (benefits, filtration, results timeline, FAQ).
   window.elToggleHeight(box, panel, apply, open)
     box   — the element whose height changes (card / row)
     panel — the content that is shown or hidden ([hidden])
     apply — function(open) that sets classes, aria and panel.hidden
   The box slides from its current height to the new one and the content
   fades. While closing, the content stays visible until the slide ends.
   Instant when the visitor prefers reduced motion. */
(function () {
  'use strict';

  if (window.elToggleHeight) return;

  var DURATION = 320;
  var EASING = 'cubic-bezier(0.4, 0, 0.2, 1)';
  var reduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

  window.elToggleHeight = function (box, panel, apply, open) {
    if (!box || !box.animate || (reduce && reduce.matches)) { apply(open); return; }

    /* Start from where the box is right now, even mid-animation */
    var start = box.getBoundingClientRect().height;
    if (box._elMotion) { box._elMotion.cancel(); box._elMotion = null; }
    if (panel && panel._elFade) { panel._elFade.cancel(); panel._elFade = null; }

    apply(open);
    var end = box.getBoundingClientRect().height;
    if (Math.abs(end - start) < 1) return;

    if (!open && panel) panel.hidden = false; /* keep the text visible while it slides shut */

    box.style.overflow = 'hidden';
    var motion = box.animate({ height: [start + 'px', end + 'px'] }, { duration: DURATION, easing: EASING });
    box._elMotion = motion;

    if (panel && panel.animate) {
      panel._elFade = panel.animate(
        { opacity: open ? [0, 1] : [1, 0] },
        { duration: open ? DURATION : DURATION * 0.6, easing: 'ease', fill: 'forwards' }
      );
    }

    motion.onfinish = function () {
      box._elMotion = null;
      box.style.overflow = '';
      if (panel) {
        if (panel._elFade) { panel._elFade.cancel(); panel._elFade = null; }
        if (!open) panel.hidden = true;
      }
    };
  };
})();
